<template>
  <default>
    <div class="activity-page">
      <bread-crumb :breadcrumbs="breadcrumbs" />

      <header class="activity-header">
        <div>
          <h1 class="activity-title">Activity</h1>
          <p class="activity-subtitle">Saved quotes you can resume and complete.</p>
        </div>
        <div class="activity-header-actions">
          <button type="button" class="activity-refresh" :disabled="refreshing" @click="refreshQuotes">
            <v-icon small color="#184679">{{ refreshing ? 'mdi-loading mdi-spin' : 'mdi-refresh' }}</v-icon>
            Refresh
          </button>
          <router-link :to="{ name: 'CustomerProductSelect' }" class="activity-link">
            <v-icon small color="#184679">mdi-plus</v-icon>
            New quote
          </router-link>
        </div>
      </header>

      <quotes ref="quotes" />
    </div>
  </default>
</template>

<script>
import Default from '@/components/layout/Default';
import BreadCrumb from '@/components/dashboard/BreadCrumb';
import Quotes from '@/components/quotes/Quotes';

export default {
  name: 'SavedQuotes',
  components: { Quotes, BreadCrumb, Default },
  data() {
    return {
      refreshing: false,
      breadcrumbs: [
        { text: 'Activity', disabled: true, to: { name: 'SavedQuotes' } },
      ],
    };
  },
  metaInfo: {
    title: 'Activity',
  },
  methods: {
    async refreshQuotes() {
      this.refreshing = true;
      try {
        await this.$store.dispatch('portalCache/fetchCustomerQuotes', { force: true });
      } finally {
        this.refreshing = false;
      }
    },
  },
};
</script>

<style scoped>
.activity-page {
  width: 100%;
}

.activity-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin: 1.25rem 0 1.5rem;
  flex-wrap: wrap;
}

.activity-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.activity-refresh {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.875rem;
  font-weight: 700;
  color: #184679;
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  padding: 8px 14px;
  cursor: pointer;
}

.activity-refresh:disabled {
  opacity: 0.6;
  cursor: default;
}

.activity-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.activity-subtitle {
  margin: 6px 0 0;
  font-size: 0.9rem;
  color: #64748b;
}

.activity-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.875rem;
  font-weight: 700;
  color: #184679;
  text-decoration: none;
  padding: 8px 14px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #fff;
}

.activity-link:hover {
  border-color: #94a3b8;
  background: #f8fafc;
}
</style>
